/** "Isletmeni ucretsiz ekle" — yeni esnaf kazanma cagrisi (vitrin + /esnaf sayfasi) */
const BENEFITS = [
  { icon: 'ri-store-2-line', text: 'Ücretsiz işletme vitrini: logon, çalışma saatlerin, ilanların' },
  { icon: 'ri-notification-3-line', text: 'Mahallende işinle ilgili bir talep açılınca anında haberin olsun' },
  { icon: 'ri-star-smile-line', text: 'İlanlarında İşletme rozeti, komşularından yorum ve puan' },
];

export default function EsnafJoin() {
  return (
    <div className="bg-[#111827] text-white rounded-2xl p-6 sm:p-8">
      <h3 className="text-2xl font-bold mb-2">İşletmeni ücretsiz ekle</h3>
      <p className="text-white/70 mb-6">Mahallendeki komşuların seni Mahallebi'de bulsun. Kayıt birkaç dakika sürer.</p>
      <ul className="space-y-3 mb-8">
        {BENEFITS.map((b) => (
          <li key={b.icon} className="flex items-start gap-3">
            <i className={`${b.icon} text-xl text-[#e77e23] shrink-0`}></i>
            <span className="text-sm text-white/90">{b.text}</span>
          </li>
        ))}
      </ul>
      <a
        href="/app/create-business"
        className="inline-flex items-center justify-center w-full sm:w-auto px-6 py-3 bg-[#e77e23] text-white font-semibold rounded-full hover:bg-[#d56d12] transition-colors"
        data-testid="esnaf-join"
      >
        İşletme hesabı aç
        <i className="ri-arrow-right-line ml-2"></i>
      </a>
      <p className="text-xs text-white/50 mt-4">
        Reklam ve iş birliği için: <a href="mailto:info@ubsbilisim.com" className="underline hover:text-white">info@ubsbilisim.com</a>
      </p>
    </div>
  );
}
